import { useEffect, useState } from 'react';

/**
 * Rotates winners items in winners block
 * Supports pause and resume of rotation
 */
export const useWinnersRotationMobile = (
    winners,
    setCurrentWinner,
    dependencies = [],
) => {
    const [intervalId, setIntervalId] = useState();
    const [currentWinnerIndex, setCurrentWinnerIndex] = useState(0);
    const ROTATION_STEP_MS = 8000;

    const stopRotation = () => {
        clearInterval(intervalId);
        setIntervalId(undefined);
    };

    const startRotation = (initialWinnerIndex = 0) => {
        const winnersCount = winners.length;
        setCurrentWinner(winners[initialWinnerIndex]);
        let newCurrentWinner = currentWinnerIndex;

        // if there are more than 1 winner - loop over them each X seconds
        if (winnersCount > 1) {
            setIntervalId(setInterval(() => {
                // start over if end of array reached
                if (winnersCount - 1 === newCurrentWinner) {
                    newCurrentWinner = -1;
                }

                newCurrentWinner += 1;

                setCurrentWinnerIndex(newCurrentWinner);
                setCurrentWinner(winners[newCurrentWinner]);
            }, ROTATION_STEP_MS));
        }
    };

    useEffect(() => {
        return stopRotation;
    }, dependencies);

    return {
        startRotation,
        stopRotation,
        currentWinnerIndex,
    };
};
